module.exports = __webpack_public_path__ + "img/ico_rank_review.cb46a63.svg";